import createOptions from "utils/createOptions";

export const INVOICE_TYPE_OPTIONS = {
  Invoice: "Акт выполненных работ",
  IntermediaryReport: "Отчет посредника",
  Undefined: "Не задано",
} as const;

export default createOptions(INVOICE_TYPE_OPTIONS, undefined, true);